import React, { useEffect } from 'react';
import { TranslateProvider, TranslateScope, Translate, } from '@pegasus/translation';
import { Dialog, Size } from '@lux/dialog';
import { Button, ButtonType, ButtonColor } from '@lux/buttons';
import { Text, Preset } from '@lux/text';
import { TextLink } from '@lux/text-link';
import { Title, TitlePreset } from '@lux/title';
import { FunctionColor } from '@lux/tokens';
import { track } from '../../lib/helpers';
import { CartStatusEnum } from '../../constants';
import { Wrapper, ButtonWrapper, PhoneNumber } from './styles';
export const ExpiredOverlay = ({ translations, extendCart, closeDialog, status, isShown, }) => {
    // send checkout click campaign into dataLayer
    const trackGoToCartClick = () => track('postpone_overlay_submit', {
        postpone_overlay_selection: 'GotoCart',
    });
    const trackContinueShopping = () => {
        track('Popup_cart_continue_shopping_submit');
        closeDialog();
    };
    const { contact_number: contactNumber } = translations.cartExpiredOverlay;
    useEffect(() => {
        if (isShown && status === CartStatusEnum.CART_EXPIRED) {
            track('popup_cart_expired_overlay_shown');
        }
        if (isShown &&
            (status === CartStatusEnum.CART_EXPIRE_IN_5_MINUTES ||
                status === CartStatusEnum.CART_EXPIRE_IN_SHORT_PERIOD)) {
            track('popup_cart_postpone_overlay_shown');
        }
        return () => {
            if (status === CartStatusEnum.CART_EXPIRED) {
                track('popup_cart_expired_overlay_closed');
            }
            if (status === CartStatusEnum.CART_EXPIRE_IN_5_MINUTES ||
                status === CartStatusEnum.CART_EXPIRE_IN_SHORT_PERIOD) {
                track('popup_cart_postpone_overlay_closed');
            }
        };
    }, [status, isShown]);
    const _extendCart = () => {
        extendCart();
        track('postpone_overlay_submit', {
            postpone_overlay_selection: 'Extend',
        });
    };
    return (React.createElement(TranslateProvider, { translations: translations },
        React.createElement(TranslateScope, { path: "cartExpiredOverlay" },
            React.createElement(Dialog, { isShown: isShown, closeDialog: closeDialog, size: Size.M, mobileFullScreen: true, isAlertDialog: true },
                React.createElement(Wrapper, null, status === CartStatusEnum.CART_EXPIRE_IN_5_MINUTES ||
                    status === CartStatusEnum.CART_EXPIRE_IN_SHORT_PERIOD ? (React.createElement(React.Fragment, null,
                    React.createElement(Title, { preset: TitlePreset.S, presetXs: TitlePreset.M },
                        React.createElement(Translate, { message: "title_timer_over" })),
                    React.createElement(Text, { preset: Preset.M },
                        React.createElement(Translate, { message: status === CartStatusEnum.CART_EXPIRE_IN_5_MINUTES
                                ? 'time_over_in_5min'
                                : 'time_over_in_short_time' })),
                    React.createElement(ButtonWrapper, null,
                        React.createElement(Button, { buttonType: ButtonType.primary, color: ButtonColor.dark, onClick: _extendCart },
                            React.createElement(Translate, { message: "extend_cart" })),
                        React.createElement(Button, { buttonType: ButtonType.primary, color: ButtonColor.primary, link: true, href: "/checkout/", onClick: trackGoToCartClick },
                            React.createElement(Translate, { message: "to_checkout" }))))) : (React.createElement(React.Fragment, null,
                    React.createElement(Title, { preset: TitlePreset.S, presetXs: TitlePreset.M },
                        React.createElement(Translate, { message: "title_timer_over" })),
                    React.createElement(Text, { preset: Preset.M },
                        React.createElement(Translate, { message: "emptied_bag" })),
                    React.createElement(Text, { preset: Preset.M, bold: true },
                        React.createElement(Translate, { message: "problem_order" })),
                    React.createElement(Text, { preset: Preset.M },
                        React.createElement(Translate, { message: "contact_us" }),
                        "\u00A0",
                        contactNumber && (React.createElement(React.Fragment, null,
                            React.createElement(PhoneNumber, { preset: Preset.M, link: true, href: `tel:${translations.cartExpiredOverlay
                                    .contact_number}`, color: FunctionColor.function100 },
                                React.createElement(Translate, { message: "contact_number" })),
                            "\u00A0")),
                        React.createElement(Translate, { message: "other_contact" }),
                        "\u00A0",
                        React.createElement(TextLink, { preset: Preset.M, link: true, href: "/contact/", color: FunctionColor.function100 },
                            React.createElement(Translate, { message: "contact_link_form" }))),
                    React.createElement(Button, { buttonType: ButtonType.primary, color: ButtonColor.primary, onClick: trackContinueShopping },
                        React.createElement(Translate, { message: "continue_shopping" })))))))));
};
//# sourceMappingURL=component.js.map